import { useStoreValue } from '@core'
import { getAppContext } from 'src/context/AppContext'

export const useLanguageValue = () =>
    useStoreValue(getAppContext().i18n.language)
